import { RadioButton, RadioGroup, Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { markersToggleDisabledAtom } from '@/atoms/vis/displaySettings';
import { showArrowsAtom } from '@/atoms/visualisation';
import { useSetQueryParams } from '@/hooks/queryParams/useSetQueryParams';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';

const PitchMarkerToggleBase = ({ isDisabled = false }: { isDisabled?: boolean }) => {
  const { t } = useTranslation('visualisation');
  const showArrows = useAtomValue(showArrowsAtom);

  const setQueryParams = useSetQueryParams();

  return (
    <RadioGroup groupId="pitch-markings-type" groupTitle={t('markings.heading')} size="regular">
      <Typography variant="bodySmall">{t('markings.description')}</Typography>
      <RadioButton
        checked={!showArrows}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.SHOW_ARROWS, 'false')}
        id="show-markers-option"
        label={t('markings.showMarkers')}
        value="false"
        size="small"
        disabled={isDisabled}
      />
      <RadioButton
        checked={showArrows}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.SHOW_ARROWS, 'true')}
        id="show-arrows-option"
        label={t('markings.showArrows')}
        value="true"
        size="small"
        disabled={isDisabled}
      />
    </RadioGroup>
  );
};

const PitchMarkerToggleWithData = () => {
  const isDisabled = useAtomValue(markersToggleDisabledAtom);

  return <PitchMarkerToggleBase isDisabled={isDisabled} />;
};

export const PitchMarkerToggle = () => (
  <Suspense fallback={<PitchMarkerToggleBase isDisabled />}>
    <PitchMarkerToggleWithData />
  </Suspense>
);
